import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '82%',
    padding: '3% 3%',
    margin: 'auto',
    minWidth: '1200px',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '20px',
    color: '#DF0C36',
    marginBottom: 7,
  },
  saveButton: {
    color: 'white',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '30%',
    marginRight: '3%',
    backgroundColor: '#DF0C36',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: '#DF0C36',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 5px white',
    },
  },
  cancelButton: {
    backgroundColor: 'white',
    color: '#DF0C36',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '27%',
    marginRight: '3%',
    boxShadow: '0px 15px 20px rgb(217 224 221 / 40%)',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: 'white',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 25px white',
    },
  },
  contentPaper: {
    margin: '0px !important',
    borderTop: '2px solid #DF0C36',
  },
  gridMargin: {
    padding: '12px 60px',
  },
  description: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '18px 48px',
    position: 'static',
    width: '80%',
    background: '#FAFAFA',
    borderRadius: '2px',
    flex: 'none',
    order: 0,
    flexGrow: 1,
    margin: '30px 0px 0px 60px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#666666',
  },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    color: '#666666',
  },
  asterisk: {
    color: '#DF0C36',
  },
  input: {
    height: 40,
    paddingRight: 0,
    width: 150,
  },
  select: {
    height: 40,
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '27px',
    color: '#403e3e',
  },
  formControl: {
    width: 160,
  },
  dropdownStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '27px',
    color: '#403e3e',
  },
  datePicker: {
    width: 150,
    marginTop: 0,
    paddingRight: 0,
  },
  importButton: {
    whiteSpace: 'nowrap',
    minWidth: 200,
    padding: '8px 16px',
    marginTop: '20px',
    height: 40,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    color: '#ffffff',
    marginBottom: 16,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  helperText: {
    marginLeft: 0,
    marginRight: 0,
    fontSize: '10px',
  },
  loader: {
    color: '#DF0C36',
    position: 'fixed',
    left: '50%',
    top: '50%',
  },
  invoiceDateMargin: {
    marginRight: 73,
  },
  activityTypeMargin: {
    marginRight: 89,
  },
  popupPaper: {
    width: '700px',
  },
  popupTitle: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: 0,
    color: '#666666',
  },
  publishIcon: {
    color: '#DF0C36',
    margin: '30px 30px',
  },
  dialogTitle: {
    marginLeft: '15px',
    marginTop: '10px',
  },
  dialogContent: {
    marginLeft: '15px',
    marginRight: '80px',
  },
  dialogActions: {
    marginRight: '80px',
    marginBottom: '20px',
  },
  dialogText: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#333333',
    textAlign: 'justify',
  },
  validateButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    color: '#ffffff',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  popupCancelButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    color: '#DF0C36',
    borderColor: '#DF0C36',
    borderRadius: 0,
    marginRight: '24px',
    '&:hover': {
      color: '#B00429',
      borderColor: '#B00429',
      backgroundColor: '#FFFFFF',
    },
  },
}));
